<template>
  <div id="page-product-label">
    <vs-card>
      <form data-vv-scope="product-label">
        <div class="vx-row pt-5 px-5">
          <div class="vx-col w-full md:w-1/2 px-8">
            <!-- bussiness name -->
            <div class="vx-row mb-2">
              <label for="">Business Name</label>
              <select-2
                class="w-full"
                :value="form.supplierId"
                @input="
                  (item) => {
                    this.form.supplierId = item && item.value
                    this.form.supplier_type = item && (item.type === 'user' ? 'user' : 'supplier')
                  }
                "
                name="Business name"
                v-validate="'required'"
                placeholder="Select Business Type"
                autocomplete
                :extra="[{ label: 'My Business', value: user.id, type: 'user' }]"
                action="supplier/getSupplierOption"
              />
              <span class="text-danger text-sm" v-show="errors.has('Business name')">{{ errors.first('Business name') }}</span>
            </div>

            <!-- product name -->
            <div class="vx-row mb-2">
              <label for="">Strain/Product Name</label>
              <vs-input icon="icon icon-file-text" v-model="form.product_name" icon-pack="feather" class="w-full" name="Product Name" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Product Name')">{{ errors.first('Product Name') }}</span>
            </div>

            <!-- bussiness address -->
            <div class="vx-row mb-2">
              <label for="">Business Address</label>
              <vs-input icon="icon icon-file-text" v-model="form.businessAddress" icon-pack="feather" class="w-full" name="Business Address" />
              <span class="text-danger text-sm" v-show="errors.has('Business Address')">{{ errors.first('Business Address') }}</span>
            </div>

            <!-- weight of contents -->
            <div class="vx-row mb-2">
              <label for="">Qty/Weight Of Contents</label>
              <vs-input icon="icon icon-file-text" v-model="form.quantity_Or_weightOfContents" icon-pack="feather" class="w-full" name="Weight Of Contents" />
              <span class="text-danger text-sm" v-show="errors.has('Weight Of Contents')">{{ errors.first('Weight Of Contents') }}</span>
            </div>

            <!-- ingredient list -->
            <div class="vx-row mb-2">
              <label for="">Ingredient List</label>
              <vs-input icon="icon icon-file-text" v-model="form.ingredientList" icon-pack="feather" class="w-full" name="Ingredient List" />
              <span class="text-danger text-sm" v-show="errors.has('Ingredient List')">{{ errors.first('Ingredient List') }}</span>
            </div>

            <!-- food allergen info -->
            <div class="vx-row mb-2">
              <label for="">Food Allergen Info</label>
              <vs-input icon="icon icon-file-text" v-model="form.foodAllergenInfo" icon-pack="feather" class="w-full" name="Food Allergen Info" />
              <span class="text-danger text-sm" v-show="errors.has('Food Allergen Info')">{{ errors.first('Food Allergen Info') }}</span>
            </div>

            <!-- nutrition information -->
            <div class="vx-row mb-2">
              <label for="">Nutrition Information</label>
              <vs-input icon="icon icon-file-text" v-model="form.nutritionInformation" icon-pack="feather" class="w-full" name="Nutrition Information" />
              <span class="text-danger text-sm" v-show="errors.has('Nutrition Information')">{{ errors.first('Nutrition Information') }}</span>
            </div>

            <!-- list of cannabis ingredient -->
            <div class="vx-row mb-2">
              <label for="">List Of Cannabis Ingredient</label>
              <vs-input icon="icon icon-file-text" v-model="form.cannabisIngredients" icon-pack="feather" class="w-full" name="Cannabis Ingredient" />
              <span class="text-danger text-sm" v-show="errors.has('Cannabis Ingredient')">{{ errors.first('Cannabis Ingredient') }}</span>
            </div>

            <!-- terpenoid potency -->
            <div class="vx-row mb-2">
              <label for="">Terpenoid Potency</label>
              <vs-input icon="icon icon-file-text" :value="form.terpenoidPotency" icon-pack="feather" class="w-full" name="Terpenoid Potency" @input="handleTerpenoidPotency" v-validate="'max:30'" />
              <span class="text-danger text-sm" v-show="errors.has('Terpenoid Potency', 'product-label')">{{ errors.first('Terpenoid Potency', 'product-label') }}</span>
            </div>
          </div>

          <div class="vx-col w-full md:w-1/2 px-8">
            <!-- serial number -->
            <div class="vx-row mb-2">
              <label for="">Serial Number</label>
              <vs-input icon="icon icon-list" v-model="form.serialNumber" icon-pack="feather" class="w-full" name="Serial Number" />
              <span class="text-danger text-sm" v-show="errors.has('Serial Number')">{{ errors.first('Serial Number') }}</span>
            </div>

            <!-- batch number -->
            <div class="vx-row mb-2">
              <label for="">Batch Number</label>
              <vs-input icon="icon icon-file-text" v-model="form.batchNumber" icon-pack="feather" class="w-full" name="Batch Number" />
              <span class="text-danger text-sm" v-show="errors.has('Batch Number')">{{ errors.first('Batch Number') }}</span>
            </div>

            <!-- thc -->
            <div class="vx-row mb-2">
              <label for="">THC Dosage in Mg/Unit</label>
              <vs-input icon="icon icon-file-text" v-model="form.THC_Dosage" icon-pack="feather" class="w-full" name="THC Dosage" />
              <span class="text-danger text-sm" v-show="errors.has('THC Dosage')">{{ errors.first('THC Dosage') }}</span>
            </div>

            <!-- lot code -->
            <div class="vx-row mb-2">
              <label for="">Lot Code</label>
              <vs-input icon="icon icon-file-text" v-model="form.lotCode" icon-pack="feather" class="w-full" name="Lot Code" />
              <span class="text-danger text-sm" v-show="errors.has('Lot Code')">{{ errors.first('Lot Code') }}</span>
            </div>

            <!-- package date -->
            <div class="vx-row mb-2 relative">
              <label for="">Packaged Date</label>
              <date-picker
                :appendToBody="false"
                v-model="form.packagedDate"
                name="Packaged Date"
                placeholder="MM-DD-YYYY"
                v-validate="'required'"
                format="MM-DD-YYYY"
                valueType="format"
                class="w-full mb-1"
              />
            </div>

            <!-- expiry date -->
            <div class="vx-row mb-2 relative">
              <label for="">Expiry Date</label>
              <date-picker
                :appendToBody="false"
                v-model="form.expiryDate"
                name="Expiry Date"
                placeholder="MM-DD-YYYY"
                v-validate="'required'"
                format="MM-DD-YYYY"
                valueType="format"
                class="w-full mb-1"
              />
            </div>

            <!-- cbd -->
            <div class="vx-row mb-2">
              <label for="">CBD %</label>
              <vs-input icon="icon icon-file-text" v-model="form.cbd" icon-pack="feather" class="w-full" name="CBD" />
              <span class="text-danger text-sm" v-show="errors.has('CBD')">{{ errors.first('CBD') }}</span>
            </div>

            <!-- thc -->
            <div class="vx-row mb-2">
              <label for="">THC %</label>
              <vs-input icon="icon icon-file-text" v-model="form.thc" icon-pack="feather" class="w-full" name="THC" />
              <span class="text-danger text-sm" v-show="errors.has('THC')">{{ errors.first('THC') }}</span>
            </div>
          </div>
        </div>

        <!-- message -->
        <div class="vx-row">
          <div class="vx-col w-full ml-5 mt-5">
            <p>
              <strong>Caution:</strong> Women should not use marijuana or medical marijuana during pregnancy because of the risk of health defects or while breastfeeding. Keep out of reach of
              children. For accidental ingestion call 1-800-222-1222
            </p>
            <p><strong>NB:</strong> This product has been tested for contaminants</p>
          </div>
        </div>

        <!-- barcodes -->
        <div class="vx-row">
          <div class="vx-col w-1/3 mt-5">
            <bar-code :options="options" :value="form.serialNumber ? form.serialNumber : 'Blank'" />
          </div>
          <div class="vx-col w-1/3 mt-5">
            <bar-code :options="options" :value="form.serialNumber ? form.serialNumber : 'Blank'" />
          </div>
          <div class="vx-col w-1/3 mt-5">
            <img src="@/assets/images/product_label/label.png" alt="latest-upload" class="rounded mb-4 user-latest-image label-image-width responsive" />
          </div>
        </div>

        <!-- action btns -->
        <div class="vx-row">
          <div class="vx-col w-full text-center">
            <vs-button class="mr-2 mt-8 vs-con-loading__container" id="update-label-details" @click="updateProductLabel()" type="filled">Update Label Details</vs-button>
            <vs-button class="mr-2 mt-8 vs-con-loading__container" color="rgb(164,218,34)" @click="openLabelModal()" type="filled" id="download-label-details">Download Label Details</vs-button>
          </div>
        </div>
      </form>
    </vs-card>

    <vs-popup ref="product-label-popup" class="holamundo" title="Product Label" :active.sync="tmpActive">
      <form data-vv-scope="print-label">
        <div class="vx-col w-full px-8">
          <div class="vx-row mb-5">
            <div class="vx-col w-full">
              <label for="">Total Label</label>
              <vs-input icon="icon icon-list" type="number" step="1" v-model="totalLabel" icon-pack="feather" class="w-full" name="Total Label" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Total Label', 'print-label')">{{ errors.first('Total Label', 'print-label') }}</span>
            </div>
            <div class="vx-col mt-5 w-full">
              <label for="">Label Size</label>
              <select-2
                class="w-full mb-1"
                autocomplete
                :value="labelSize"
                @input="(item) => (labelSize = item.value)"
                placeholder="Select Printer Type"
                name="Printer Type"
                :options="labelSizes"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Printer Type', 'print-label')">{{ errors.first('Printer Type', 'print-label') }}</span>
            </div>
          </div>

          <div class="vx-row justify-center">
            <vs-button @click="downloadLabel()" type="relief">Download Label</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>

    <!-- pdfs -->
    <print-pdf v-if="printLabel" :totalLabel="Number(totalLabel)" @close="close" :autoPrintPreview="true">
      <label-size-four-x-one v-if="labelSize === '4X1'" :totalLabel="totalLabel" :product="productDataWithLabel" :supplier="supplierData" />
      <label-size-four-x-two v-if="labelSize === '4X2'" :totalLabel="totalLabel" :product="productDataWithLabel" :supplier="supplierData" />
    </print-pdf>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import BarCode from '@/components/utils/BarCode.vue'
import PrintPdf from '@/components/custom/PrintPdf.vue'
import LabelSizeFourXOne from '@/views/products/pdf/LabelSizeFourXOne.vue'
import LabelSizeFourXTwo from '@/views/products/pdf/LabelSizeFourXTwo.vue'

export default {
  name: 'ProductLabel',
  components: {
    Select2,
    DatePicker,
    BarCode,
    PrintPdf,
    LabelSizeFourXOne,
    LabelSizeFourXTwo
  },

  data() {
    return {
      form: {
        product_name: '',
        supplierId: null,
        supplier_type: null,
        productId: null,
        businessAddress: null,
        quantity_Or_weightOfContents: null,
        ingredientList: null,
        foodAllergenInfo: null,
        nutritionInformation: null,
        cannabisIngredients: null,
        terpenoidPotency: null,
        serialNumber: null,
        batchNumber: null,
        THC_Dosage: null,
        lotCode: null,
        packagedDate: moment().format('MM-DD-YYYY'),
        expiryDate: moment().format('MM-DD-YYYY'),
        cbd: null,
        thc: null
      },
      options: {
        width: 3,
        height: 90,
        displayValue: false
      },
      labelSize: '',
      tmpActive: false,
      labelSizes: [
        { label: '4X1 (20 Labels in one sheet)', value: '4X1' },
        { label: '4X2 (10 Labels in one sheet)', value: '4X2' }
      ],
      totalLabel: 1,
      printLabel: false,
      productDataWithLabel: {},
      supplierData: {}
    }
  },
  async mounted() {
    await this.getProductById(this.$route.params.id)
    try {
      const { product } = await this.getProductLabelDetails(this.$route.params.id)

      this.form.product_name = (product.productLabel && product.productLabel.product_name) || product.product_name
      this.form.productId = product.id
      this.form.supplierId = (product.productLabel && product.productLabel.supplierId) || this.user.id
      this.form.supplier_type = (product.productLabel && product.productLabel.supplier_type) || 'user'
      this.form.serialNumber = product.productLabel && product.productLabel.serialNumber
      this.form.batchNumber = product.productLabel && product.productLabel.batchNumber
      this.form.businessAddress = product.productLabel && product.productLabel.businessAddress
      this.form.terpenoidPotency = product.productLabel && product.productLabel.terpenoidPotency
      this.form.THC_Dosage = product.productLabel && product.productLabel.THC_Dosage
      this.form.lotCode = product.productLabel && product.productLabel.lotCode
      this.form.packagedDate = moment(product.productLabel && product.productLabel.packagedDate).format('MM-DD-YYYY')
      this.form.expiryDate = moment(product.productLabel && product.productLabel.expiryDate).format('MM-DD-YYYY')
      this.form.cbd = product.productLabel && product.productLabel.cbd
      this.form.thc = product.productLabel && product.productLabel.thc
      this.form.quantity_Or_weightOfContents = product.productLabel && product.productLabel.quantity_Or_weightOfContents
      this.form.ingredientList = product.productLabel && product.productLabel.ingredientList
      this.form.foodAllergenInfo = product.productLabel && product.productLabel.foodAllergenInfo
      this.form.nutritionInformation = product.productLabel && product.productLabel.nutritionInformation
      this.form.cannabisIngredients = product.productLabel && product.productLabel.nutritionInformation
    } catch ({ message }) {
      this.processing = false
      this.$vs.notify({
        title: 'Error',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('product', ['product']),

    //   validate form
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    ...mapActions('product', ['getProductById', 'updateProductLabelDetails', 'getProductLabelDetails']),
    async updateProductLabel() {
      // validate data
      if (!(await this.$validator.validateAll('product-label'))) {
        return false
      }

      try {
        const { message } = await this.updateProductLabelDetails({
          id: this.product.id,
          data: this.form
        })

        // this.$router.push({ name: 'product-label' })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async openLabelModal() {
      this.tmpActive = true
    },
    async downloadLabel() {
      //validate inventory details
      const check1 = await this.$validator.validateAll('print-label')

      if (!check1) {
        this.$vs.notify({
          title: 'Error',
          text: 'please fill the form first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return false
      }

      this.loading = true

      try {
        const { product, supplier } = await this.getProductLabelDetails(this.$route.params.id)
        this.productDataWithLabel = product
        this.supplierData = supplier
        this.loading = false
      } catch ({ message }) {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: 'Please Fill The Form',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      this.printLabel = true
    },
    close() {
      this.printLabel = false
    },

    // handle terpenoid potency
    handleTerpenoidPotency(item) {
      if (item.length >= 30) {
        this.$vs.notify({
          title: 'Error',
          // eslint-disable-next-line quotes
          text: "Terpenoid Potency can't have more than 30 digits",
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false
      }

      this.form.terpenoidPotency = item
    }
  },

  beforeRouteLeave(_, __, next) {
    this.tmpActive = false
    next()
  }
}
</script>
<style lang="css">
.label-image-width {
  width: 180px !important;
  height: 120px;
}
</style>
